import type { EnvironmentProviders, Provider } from '@angular/core';

/**
 * Represents the type for a feature flag provider
 */
/* eslint-disable @typescript-eslint/naming-convention */
export enum FlipperFeatureKind {
  // eslint-disable
  FINGERPRINTING,
  NAVIGATION_LISTENER,
  CUSTOM
}
/* eslint-enable @typescript-eslint/naming-convention */

export declare interface FlipperFeature<FeatureKind extends FlipperFeatureKind> {
  kind: FeatureKind;
  providers: Array<Provider | EnvironmentProviders>;
}

/**
 * Helper function to create an object that represents a Router feature.
 */
export function flipperFeature<FeatureKind extends FlipperFeatureKind>(
  kind: FeatureKind,
  providers: Array<Provider | EnvironmentProviders>
): FlipperFeature<FeatureKind> {
  return { kind: kind, providers: providers };
}
